import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductListing from "@/components/ProductListing";
import Reveal from "@/components/Reveal";

export default function MartPage({ slug: propSlug }) {
  const params = useParams();
  const slug = propSlug || params.slug;
  const [mart, setMart] = useState(null);

  useEffect(() => {
    api.get(`/marts/${slug}`).then((r) => setMart(r.data)).catch(() => setMart(null));
    window.scrollTo(0, 0);
  }, [slug]);

  if (!mart) return <div className="py-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <div>
      <div className="px-3 md:px-6 pt-4">
        <div className="relative h-64 md:h-80 overflow-hidden rounded-3xl">
          <img src={mart.image} alt={mart.name} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0" style={{ background: `linear-gradient(90deg, ${mart.color}E6, ${mart.color}55, transparent)` }} />
          <Reveal className="relative h-full flex flex-col justify-center px-8 md:px-16 max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/90">KRVMart</span>
            <h1 className="mt-2 text-4xl md:text-5xl font-extrabold text-white">{mart.name}</h1>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-white/80">{mart.tagline}</p>
            <p className="mt-3 max-w-lg text-white/90">{mart.description}</p>
          </Reveal>
        </div>
      </div>
      <ProductListing mart={slug} martConfig={mart} title={mart.name} />
    </div>
  );
}
